import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import { connect } from 'react-redux';

import { getBrandName, getBrandCode } from '../brand/brandSelectors';
import { getBrandUrl, getStaticMediaURL } from '../app/bootstrap';
import headerMessages from './message/HeaderMessage';
import { trackHeaderFooterClick } from '../segment/segmentModule';


const Logo = (props) => {
    const {
        intl, brandName, brandCode, trackExternalLinkClickAction
    } = props;
    const linkCopy = intl.formatMessage(headerMessages.linkText, { brandName });
    const logoSrc = intl.formatMessage(headerMessages.logoSrc, { brandCode });
    const imgUrl = `${getStaticMediaURL()}/images/${brandCode}/${logoSrc}`;
    const destinationUrl = getBrandUrl();

    const handleOnClick = () => {
        trackExternalLinkClickAction('Logo Clicked', {
            title: linkCopy,
            destinationUrl
        });
    };

    return (
        <div className='Logo'>
            <a href={destinationUrl} target="_blank" rel="noopener noreferrer" onClick={handleOnClick}>
                <img
                    src={imgUrl}
                    alt={`${linkCopy} - opens in a new window`}
                    height='100%'
                    width='100%'
                />
            </a>
        </div>
    );
};

Logo.propTypes = {
    brandName: PropTypes.string.isRequired,
    brandCode: PropTypes.string.isRequired,
    intl: intlShape.isRequired,
    trackExternalLinkClickAction: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
    brandName: getBrandName(state),
    brandCode: getBrandCode(state)
});

const mapDispatchToProps = {
    trackExternalLinkClickAction: trackHeaderFooterClick
};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(Logo));
